import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { getCurrentLanguageKey, getLanguageSection } from "../../../shared/services/languageService";

const ACCEPTED_COOKIE = "multimediaTermsAccepted";

// Mismos enlaces por idioma que usa AgencyCreateForm para los términos de multimedia.
const TERMS_LINKS = {
  esp: "https://marivalagents.com/es/terminos-y-condiciones-multimedia",
  eng: "https://marivalagents.com/multimedia-terms-and-conditions"
};

function MultimediaLibraryModal() {
  const language = getLanguageSection("multimediamodal");
  const currentLanguage = getCurrentLanguageKey();
  const termsLink = currentLanguage === "esp" ? TERMS_LINKS.esp : TERMS_LINKS.eng;

  // Abierto por defecto, salvo que el usuario ya haya aceptado antes.
  const [isOpen, setIsOpen] = useState(() => Cookies.get(ACCEPTED_COOKIE) !== "true");
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    if (typeof document === "undefined" || !isOpen) return undefined;

    // Bloquea el scroll del fondo mientras el modal está abierto.
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const handleContinue = () => {
    Cookies.set(ACCEPTED_COOKIE, "true", { expires: 365 });
    setIsOpen(false);
  };

  return (
    // Sin botón de cerrar y sin onClick en el backdrop: solo sale al aceptar y continuar.
    <div className="fixed inset-0 z-[1300] flex items-center justify-center bg-[#151b3f]/70 px-4 py-6 backdrop-blur-sm" role="dialog" aria-modal="true">
      <div className="w-full max-w-[460px] rounded-2xl bg-white p-8 text-center shadow-[0_24px_70px_rgba(17,24,63,0.28)]">
        <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-[#eaf6fb] text-marival-blue">
          <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M4 6h16v12H4V6Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
            <path d="m5 16 4.5-4.5 3 3L16 11l3 3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="9" cy="9.5" r="1.2" fill="currentColor" />
          </svg>
        </span>

        <p className="m-0 mt-4 inline-block rounded-full bg-[#fdf0d5] px-3 py-1 text-[11px] font-black uppercase tracking-[0.18em] text-[#c08a12]">
          {language.badge}
        </p>

        <h2 className="m-0 mt-4 text-2xl font-black text-[#151b3f]">
          {language.heading}
        </h2>

        <p className="m-0 mt-3 text-sm leading-6 text-slate-600">
          {language.intro}
        </p>

        <a
          href={termsLink}
          target="_blank"
          rel="noreferrer"
          className="mt-6 inline-flex h-11 w-full items-center justify-center gap-2 rounded-xl bg-marival-navy px-5 text-sm font-black text-white hover:bg-marival-blue"
        >
          <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M14 3H7a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7l-4-4Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
            <path d="M14 3v4h4" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
          </svg>
          {language.termsButton}
        </a>

        <div className="mt-4 flex items-start gap-3 rounded-xl border border-slate-200 bg-slate-50 p-4 text-left text-sm leading-6 text-slate-600">
          <input
            id="multimedia-terms-accept"
            type="checkbox"
            checked={accepted}
            onChange={(event) => setAccepted(event.target.checked)}
            className="mt-1 h-4 w-4 shrink-0 rounded border-slate-300 accent-[#f6c833]"
          />
          <label htmlFor="multimedia-terms-accept" className="m-0 font-normal">
            {language.acceptTextBefore}
            <a href={termsLink} target="_blank" rel="noreferrer" className="text-[#4aa6cf] underline hover:text-[#11183f]">
              {language.acceptLinkText}
            </a>
            {language.acceptTextAfter}
          </label>
        </div>

        {accepted ? (
          <button
            type="button"
            onClick={handleContinue}
            className="mt-4 inline-flex h-11 w-full items-center justify-center rounded-xl border-0 bg-[#f6c833] px-5 text-sm font-black text-[#11183f] hover:bg-[#ffd84d]"
          >
            {language.continueButton}
          </button>
        ) : null}
      </div>
    </div>
  );
}

export default MultimediaLibraryModal;
